import { Navigate } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'

import { DonationsWrapper } from '../../components'

export default function DonationsPage() {
  const organization = AuthService.getOrg()?.[0]

  if (!organization?.setting?.donationsEnabled) {
    return <Navigate to="/settings/organization-information" replace />
  }

  return <DonationsWrapper />
}
